import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-bold text-2xl mt-4 mb-3" }
const _hoisted_2 = ["innerHTML"]

import { ref, onMounted, watch } from "vue";
import { v4 as uuidv4 } from 'uuid';


export default /*#__PURE__*/_defineComponent({
  __name: 'HiddenField',
  props: {
    field: Object,
    isTestComplete: Boolean,
},
  setup(__props) {

const props = __props;



const container = ref();

watch(() => props.isTestComplete, () => {
    console.log(props.field?.name, props.isTestComplete)
    if (props.field?.name === 'test-complete') {
        setValue();
    }
});

const getDeviceType = () => {
    const width = window.innerWidth;

    if (width <= 480) {
        return 'Mobile';
    } else if (width <= 768) {
        return 'Tablet';
    } else {
        return 'Desktop';
    }
};

const getContrastPreference = () => {
    if (window.matchMedia('(prefers-contrast: more)').matches) {
        return 'High Contrast';
    } else if (window.matchMedia('(prefers-contrast: less)').matches) {
        return 'Low Contrast';
    } else if (window.matchMedia('(prefers-contrast: no-preference)').matches) {
        return 'No Preference';
    } else {
        return 'Contrast Preference Not Supported';
    }
}

const getMagnificationLevel = () => {
    const magnification = Math.round(((window.outerWidth) / window.innerWidth) * 100) / 100;

    return `Magnification Level: ${magnification}`;
}

const getLocation = async () => {
    try {
        const response = await fetch('https://ipinfo.io/json');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const json = await response.json();
        return JSON.stringify(json);
    } catch (error) {
        console.error('Error fetching location:', error);
    }
}

const getValue = async () => {
    switch (props.field?.name) {
        case 'user-id':
            return uuidv4();
        case 'user-location':
            return getLocation();
        case 'magnification':
            return getMagnificationLevel();
        case 'contrast':
            return getContrastPreference();
        case 'device-type':
            return getDeviceType();
        case 'test-complete':
            return props.isTestComplete ? 'Yes' : 'No';
    }
}

const setValue = async () => {
    if (props.field?.name && container.value) {
        const input = container.value.querySelector('input');
        if (input) {
            input.value = await getValue();
        }
    }
}

onMounted(() => {
    setValue();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "hidden-container"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["hidden", `hidden-field-${__props.field.name}`])
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.field.label), 1),
      _createElementVNode("div", {
        innerHTML: __props.field.html
      }, null, 8, _hoisted_2)
    ], 2)
  ], 512))
}
}

})